// extracted by css-extract-rspack-plugin
export default {"topBarRoot":"topBarRoot-crWS81"};